import './../../style/dragDrop.css';
import './../../style/dndSmallScreen.css';
import {randomShuffle } from "./util"
import DragElement from "./DragElement"
import DropElement from "./DropElement"
import { useContext, useEffect, useState } from 'react';
import { isNeitherNullNorUndefined } from '../../utils/functions';
import {adjustListTags } from "../Page/utils/htmlAdjustments"
import {parseContent} from "./util"
import {audioBaseURL } from "../../constants"

export default function DropElementSmall({content, 
        identifier,
        currentlyClicked, 
        occupied, 
        informAboutOccupation,
        readyToReceive
    }){
    

    useEffect(() => {

    }, [])

    function handleClick(){
        if(readyToReceive){
            informAboutOccupation(identifier)
        }
    }


    return (
    <div className={occupied ? 'dndItem dropElement droppedOnSmallScreen' : readyToReceive ? 'dndItem dropElement readyToReceive ' : 'dndItem dropElement '}
        onClick={handleClick}
    >
        <div className='flex flex-row'>
            <div className='ml-2'>{content}</div>
        </div>
        {
            occupied && 
            <div className="droppedElement ">
                {parseContent(occupied.content).contentBeforeAudio && 
           //     <div>{occupied.content}</div>
           //TODO: content doesn't have contentBeforeAudio, audioFileName and contentAfterAudio yet! !!!!!!!!!!!!!!!!
                <div className=" "
                    dangerouslySetInnerHTML={{__html: parseContent(occupied.content).contentBeforeAudio}}
                />
                }
                {
                    parseContent(occupied.content).audioFileName && <audio controls src={audioBaseURL + parseContent(occupied.content).audioFileName}  ></audio>
                }
                {parseContent(occupied.content).contentAfterAudio && 
                <div className=" "
                    dangerouslySetInnerHTML={{__html: parseContent(occupied.content).contentAfterAudio}}
                />
                }
            </div>
        }
    </div>
    
    )
}